/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { protectedProfileSchema } from "./protectedProfileSchema.ts"
import { z } from "zod/v4"

export const followedUserProfileSchema = z.object({
  get profile() {
    return protectedProfileSchema
  },
  protectedProfileSymmetricKey: z
    .string()
    .describe(
      "The profile symmetric key of the user you follow, encrypted using your RSA public key.",
    ),
})
